<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h4 class="card-title">
          Client Summary
        </h4>
      </div>
      <form v-on:submit="loadReport">
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label">Client Type</label>
              <select class="form-control" v-model="filter.PTR_ID">
                <option value="0">All</option>
                <option v-for="item in partnerTypes" :key="item.PTR_ID" :value="item.ID">
                  {{ item.Title }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label">Risk Category</label>
              <select class="form-control" v-model="filter.RiskCategory">
                <option value="0">All</option>
                <option value="1">Low</option>
                <option value="2">Medium</option>
                <option value="3">High</option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="float-right">
            <button class="btn btn-success btn-sm" type="submit">Load Summary</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default ({
    data() {
      return {
        filter: { PTR_ID: 0, RiskCategory: 0 },
        partnerTypes: [],
        list: [],
      };
    },
    created: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/UICApi/pageLoadClientDropdown')
          .then(function (res) {
            endReq();
            vm.partnerTypes = res.data.partnerTypes;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      loadReport(e) {
        e.preventDefault();
        var vm = this;
        console.log('Filter PTR_ID:', vm.filter.PTR_ID);
        console.log('Filter RiskCategory:', vm.filter.RiskCategory);

        const url = "../UIC/ClientSummaryPrint?PTR_ID=" + vm.filter.PTR_ID + "&RiskCategory=" + vm.filter.RiskCategory;
        console.log('URL:', url);
        window.open(url, "_blank");
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/ims/ClientSummary.vue